module.exports = __webpack_public_path__ + "img/mastercard.39dd639c.png";